<template>
  <div v-if="element" :class="`${element.compData.type}-theme-${element.compData.styleId}`"
    :style="{...getStyles({...element.compData.styles, wrapHeight: element.boxStyle.height}),
    width: element.width + 'px',
    height: element.height + 'px',}"
    >
   <Table size="small" :show-header="element.compData.tableHeaderShow"
     :columns="element.compData.data.columns" :data="element.compData.data.data"  @on-cell-click="clickCell"></Table>
    <div v-if="fontStyleHead" v-html="fontStyleHead"></div>
    <div v-if="fontStyleBody" v-html="fontStyleBody"></div>
  </div>
</template>

<script>
import { Table } from 'view-design'
import 'view-design/dist/styles/iview.css'
import { fontFamily } from '@/util/editor/fonts/fontFamily'

export default {
  name: 'CompTable',
  props: {
    element: {
      type: Object,
      default: null,
      require: true
    }
  },
  components: {
    Table
  },
  data: () => {
    return {
      // loading: true
      fontStyleHeadName: null,
      fontStyleHeadUrl: null,
      fontStyleBodyName: null,
      fontStyleBodyUrl: null
    }
  },
  computed: {
    plugin: function() {
      return this.$getPlugin(this.element.id)
    },
    // 组件字体style html代码 表头
    fontStyleHead() {
      if (!this.fontStyleHeadName || this.fontStyleHeadName == '' || !this.fontStyleHeadUrl || this.fontStyleHeadUrl == '' ) return 
      return `<style>
        @font-face {
          font-family: ${this.fontStyleHeadName}; 
          ${this.fontStyleHeadUrl !== '' ? 'src: url(' + this.fontStyleHeadUrl + ')' : ''}
        }
      </style>`
    },
    // 组件字体style html代码 表格内容
    fontStyleBody() {
      if (!this.fontStyleBodyName || this.fontStyleBodyName == '' || !this.fontStyleBodyUrl || this.fontStyleBodyUrl == '' ) return 
      return `<style>
        @font-face {
          font-family: ${this.fontStyleBodyName}; 
          ${this.fontStyleBodyUrl !== '' ? 'src: url(' + this.fontStyleBodyUrl + ')' : ''}
        }
      </style>`
    },
  },
  mounted () {
    // setTimeout(() => {
    //   this.loading = false
    // }, 1234)
    this.$blueMap.trigger({
      nodeType: 'plugin',
      pluginId: this.element.id,
      dataKey: 'onmounted',
      eventData: {
        value: null,
        data: this.plugin,
        event: null
      }
    })
    this.handleUpdateFontStyleHead()
    this.handleUpdateFontStyleBody()
  },
  methods: {
    /**
     * 动态添加自定义字体 表头
     */
    handleUpdateFontStyleHead() {
      if (!this.element.compData.styles.headFontFamily) return
      const font = fontFamily.filter( it => it.name === this.element.compData.styles.headFontFamily)[0]
      if (font.name == '') return
      this.fontStyleHeadName = font.name
      this.fontStyleHeadUrl = font.url
    },
    /**
     * 动态添加自定义字体 表格主体
     */
    handleUpdateFontStyleBody() {
      if (!this.element.compData.styles.bodyFontFamily) return
      const font = fontFamily.filter( it => it.name === this.element.compData.styles.bodyFontFamily)[0]
      if (font.name == '') return
      this.fontStyleBodyName = font.name
      this.fontStyleBodyUrl = font.url
    },
    clickCell(row,column,data,event){
      this.$blueMap.trigger({
        nodeType: 'plugin',
        pluginId: this.element.id,
        dataKey: 'onclick',
        eventData: {
          value: data,
          data: this.plugin,
          event: null
        }
      })
    },
    getStyles (styles) {
      if (!styles) return
      const res = {}
      Object.keys(styles).forEach((item) => {
        res[`--${item}`] = (typeof styles[item] === 'number') ? styles[item] + 'px' : styles[item]
      })
      return res
    }
  }
}
</script>

<style lang='less' scoped>
/deep/ .ivu-table {
  background-color: transparent;
  // border-radius: 20px;
  &:before {
    content: "";
    width: 100%;
    height: 0;
    position: absolute;
    left: 0;
    bottom: 0;
    background-color: #17233d;
    z-index: 0;
  }
}
/deep/ .ivu-table-cell {
  white-space: nowrap;
  word-break: break-all;
}
/deep/.ivu-table-header {
  height: var(--headHeigth);
  thead {
    height: var(--headHeigth);
    tr {
      height: var(--headHeigth);
      th {
        background: var(--headBgColor);
        font-size: var(--headFontSize);
        font-family: var(--headFontFamily) !important;
        color: var(--headFontColor);
        text-align: var(--headtextAlign);
        height: var(--headHeigth);
        border: 0;
        padding: 0 !important;
        .ivu-table-cell {
          display: block;
          height: var(--headHeigth);
          line-height: var(--headHeigth);
          span{
            display: block;
          }
        }
      }
    }
  }
}
/deep/.ivu-table-body {
  width: 100%;
  height: calc(var(--wrapHeight) - var(--headHeigth));
  overflow-y: auto;
  overflow-x: hidden;
  // border-radius: 0 0 20px 20px;
  /*定义滚动条样式（高宽及背景）*/
  &::-webkit-scrollbar {
    width: 10px;
    height: 1px;
    background: rgba(255, 255, 255, 0.3);
  }
  /*定义滚动条轨道（凹槽）样式*/
  &::-webkit-scrollbar-track {
    display: none;
    border-radius: 10px;
  }
  /*定义滑块 样式*/
  &::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background-color: var(--tableBarColor);
  }
  tbody tr:nth-child(2n) td {
    background-color: var(--bodyevenBgColor);
  }
  tbody tr:nth-child(2n-1) td {
    background-color: var(--bodyoldBgColor);
  }
  tbody td {
    font-size: var(--bodyFontSize);
    font-family: var(--bodyFontFamily) !important;
    color: var(--bodyFontColor);
    text-align: var(--bodyTextAlign);
    overflow: hidden;
    text-overflow: ellipsis;
    height: var(--bodyHeigth);
    border-bottom: 0;
  }
}
</style>
